import Article from '@/learn/entities/article.entity';

export default class FeaturedNews {
  articles!: Article[];

  constructor(data: any = []) {
    this.articles = [];
    const articlesFromResponse = data ?? [];
    articlesFromResponse.forEach((retrievedArticle: any) => {
      const article = new Article(retrievedArticle);
      this.articles.push(article);
    });
  }
}
